import {
  CouponInfoSheet,
  MoreCouponsSection as MoreCouponSectionType,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {COLORS} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import styled from 'styled-components';
import {CouponStreamHeadline} from './CouponStreamHeadline';
import {CouponWalletCouponsStream} from './CouponWalletCouponsStream';

export const MoreCouponsSection: FC<
  MoreCouponSectionType & {
    stateManagerCustomKey: string;
    handleInfoIconClick: (couponInfo?: CouponInfoSheet) => void;
    setSelectedProduct?: (product: Product | undefined) => void;
    paused?: boolean;
    className?: string;
    makeInert: boolean;
  }
> = ({
  coupons,
  headline,
  stateManagerCustomKey,
  handleInfoIconClick,
  setSelectedProduct,
  paused,
  className,
  makeInert,
}) => {
  return (
    <Wrapper
      inert={makeInert}
      data-testid="moreCouponsSection"
      className={className}
    >
      <CouponStreamHeadline count={coupons.length} headline={headline} />
      <CouponWalletCouponsStream
        coupons={coupons}
        stateManagerCustomKey={stateManagerCustomKey}
        handleInfoIconClick={handleInfoIconClick}
        setSelectedProduct={setSelectedProduct}
        paused={paused}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background: ${COLORS.White};
  border-radius: 16px 16px 0 0;
  padding-top: 8px;
  position: relative;
  flex: 1;

  [data-paused-section='true'] & {
    opacity: 0.3;
    pointer-events: none;
    cursor: none;
  }
`;
